import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { motion } from "motion/react";
import React from "react";
import { useOtpFlow } from "../hooks/useOtpFlow";
import type { OtpFlowName } from "../utils/types";

import * as styles from "./OtpVerification.module.scss";

type OtpErrorProps = {
  flow: OtpFlowName;
};

export const OtpInlineError = ({ flow }: OtpErrorProps) => {
  const otp = useOtpFlow(flow);
  const errorMessage = otp.store((s) => s.errorMessage);

  return errorMessage ? (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
      exit={{ opacity: 0 }}
    >
      {errorMessage}{" "}
      <SupportLink className={styles.smallSupportLink} hideChevron openLiveChat>
        Contact Support
      </SupportLink>
    </motion.div>
  ) : null;
};
